import { motion } from "framer-motion";

import Introduction from "./mainPage/Introduction";
import About from "./mainPage/About";
import Pricing from "./mainPage/Pricing";
import Footer from "./mainPage/Footer";
import PartnerCompanies from "../../utils/components/PartnerCompanies";
import AdsSection from "../../utils/components/AdsSection";
import Contact from "./mainPage/footer/Contact";

const sectionAnimation = {
    hidden: { opacity: 0, y: 60 },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 1.2
        }
    }
};

const components = [
    <Introduction/>,

    <AdsSection type="big" />,

    <PartnerCompanies/>,

    <About />,

    <AdsSection type="medium" />,
    <AdsSection type="small" />,

    <Pricing/>,

    <AdsSection type="small" />,

    <Contact/>,
]


export default function Main() {
    return (
        <main>
            {
                components.map((component, index) => (
                    <div key={index}>
                        <motion.section
                            initial={'hidden'}
                            animate={'show'}
                            variants={sectionAnimation}
                        >
                            {component}
                        </motion.section>
                    </div>
                ))
            }

            <Footer />
        </main>
    );
}